import { TableColumn, TableRow } from '@/components/Table/types';
import { t } from 'i18next';
import { Trans } from 'react-i18next';

type EndDateColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const endDateColumnConfig = <T extends TableRow>({
  options,
}: EndDateColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'endDate',
  label: <Trans i18nKey="end_date" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">
      {value && new Date(value).getFullYear() > 1
        ? new Date(value).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          })
        : t('on_going')}
    </div>
  ),
  acessorKey: 'endDate',
  sortable: true,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
